export const FEATURE_TOGGLE_KEY_PREFIX = 'ww_ft_';
export const FEATURE_TOGGLE_KEY_PREFIX_V2 = `${FEATURE_TOGGLE_KEY_PREFIX}v2_`;

export enum AppBannerValues {
    small = 'small',
    smart = 'smart',
    none = 'none',
    micro = 'micro',
}

export enum PdpLooksInfusionVariant {
    'none',
    'top',
    'bottom',
}

export enum p100AddToWishlistMobileVariant {
    control = 'control',
    variantA = 'variantA',
}

export enum p100FiltersRedesignVariant {
    control = 'control',
    externalSorting = 'externalSorting',
    rectangleFilters = 'rectangleFilters',
}

export const StringFeatureToggleOptions = {
    p100AppBanner: AppBannerValues,
    p100PdpLooksInfusion: PdpLooksInfusionVariant,
    p100AddToWishlistMobile: p100AddToWishlistMobileVariant,
    p100FiltersRedesign: p100FiltersRedesignVariant,
};

type StringFeatureToggles = Partial<
    { [P in keyof typeof StringFeatureToggleOptions]: keyof typeof StringFeatureToggleOptions[P] }
>;

export interface BooleanFeatureToggles {
    clubHeaderBarBanner?: boolean;
    clubLinkTabHighlight?: boolean;
    isBlackFridayActive?: boolean;
    isCyberMondayActive?: boolean;
    isDefaultCookieBannerEnabled?: boolean;
    isFacebookLoginDesktopEnabled?: boolean;
    isOneTrustCookieBannerEnabled?: boolean;
    isPdpTaxDisclaimerEnabled?: boolean;
    isNewTranslationModeEnabled?: boolean;
    isSpecialSalesEnabled?: boolean;
    isNativeVideoPlayerEnabled?: boolean;
    interiorServiceInNav?: boolean;
    showTranslation?: boolean;
    specialPrice?: boolean;

    // launch darkly
    p100PdpShowMoodImageFirst?: boolean;
    p100PdpValueProps?: boolean;
    p100ShowNewS2CBanner?: boolean;
    p100HotjarTracker?: boolean;
    shopDeliveryTimePromise?: boolean;
    shopBellaCart?: boolean;
    shopBellaCheckout?: boolean;
    p100IncreasedDesktopPageWidth?: boolean;
    p100NewLooksWishlist?: boolean;
    p100ImageOnHoverPlp?: boolean;
    p100PrlBoostDecrease?: boolean;
    p100PrlBoostIncrease?: boolean;
    p100UseRedisCache?: boolean;
    p100UsePDPCache?: boolean;
    p100CategoryBubblesDisabledDesktop?: boolean;
    p100PdpLooksSlider?: boolean;
    shopSegmentIntegration?: boolean;
    p100PdpThreeDImage?: boolean;
    p100ForceClubRegistrationPopup?: boolean;
    p100DeliveryTimesV2?: boolean;
    p100PromotionalElementsLlp?: boolean;
    p100PlpLooksInfusion?: boolean;
    p100CISLPPosition?: boolean;
    shopSeoFilterValueUnderProductTitle?: boolean;
    p100PrefetchApiServerSide?: boolean;
    p100WishlistCountServerSide?: boolean;
    p100QuantitySelector?: boolean;
    p100SignupOverlayMicroFrontend?: boolean;
    p100EnableEnhancedCrossSaleRecommendations?: boolean;
    p100ShowEnhancedCrossSaleRecommendations?: boolean;
    p100PlpInfusion?: boolean;
    p100LdpInfusion?: boolean;
    p100ShowS2CBanner?: boolean;
    p100BestSellerInfusion?: boolean;
    p100CartCountServerSide?: boolean;
    p100PdpSizeSelectorNote?: boolean;
    shopAssemblyService?: boolean;
    p100OnClickForceClubRegistrationPopup?: boolean;
    p100IdsHeaderDropdown?: boolean;
    p100WestwingDeliveryService?: boolean;
    p100RevisedMobileHeader?: boolean;
    p100IdsDesktopFlyout?: boolean;
    p100ColorVariantsPlp?: boolean;
    p100ColorVariantsPdp?: boolean;

    // query toggles
    skuDiver?: boolean;
    p100Pdp?: boolean;
    assemblyService?: boolean;
    brazeReadyDebug?: boolean;

    // FeatureToggle for the Interior Design Service MicroFrontend
    p100IdsClientSideNavigation?: boolean;
}

export type FeatureToggles = BooleanFeatureToggles & StringFeatureToggles;
